import React from 'react';
import PropTypes from 'prop-types';
import PageSection from '../PageSection';
import ImageZoom from '../ImageZoom';

const ImageSection = ({ image, imageAlt }) => {
  return (
    <PageSection maxWidth={'md'} spacing={'slim'}>
      <ImageZoom>
        <img style={{ height: 'auto', width: '100%' }} src={image} alt={imageAlt} />
      </ImageZoom>
    </PageSection>
  );
};

ImageSection.propTypes = {
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
};

ImageSection.defaultProps = {};

export default ImageSection;
